<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="cabecera">
        <v-flex xs9>
          <v-icon>edit</v-icon> Reprogramación de vacaciones</v-flex
        >
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <p class="texto">
              <strong class="texto">Fecha desde: </strong
              >{{ this.form.fecha_desde }}
            </p>
            <p class="texto">
              <strong class="texto">Fecha hasta: </strong
              >{{ this.form.fecha_hasta }}
            </p>
            <p class="texto">
              <strong class="texto">Días para reprogramar: </strong
              >{{ this.form.total_dias }}
            </p>
            <p class="subtitulo"><strong>fecha de reprogramación: </strong></p>

            <v-layout wrap>
              <v-flex md6>
                <v-autocomplete
                  :items="motivos_reprogramacion"
                  item-value="valor"
                  item-text="valor"
                  v-model="form.motivo_reprogramacion"
                  label="Motivo de la reprogramación"
                  maxlength="150"
                  :rules="$validate(['required'])"
                  required
                />
              </v-flex>
              <v-flex md6>
                <v-textarea
                  v-if="form.motivo_reprogramacion == 'Otros'"
                  v-model="form.justificacion_reprogramacion"
                  class="v_card"
                  rows="1"
                  label="Justificación de la reprogramación"
                  background-color="amber lighten-4"
                  :rules="$validate(['required'])"
                  required
                >
                </v-textarea>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <p><strong>Ingrese la fecha de su reprogramación: </strong></p>
            </v-layout>
            <v-layout wrap>
              <v-flex md6>
                <v-text-field
                  @input="calculaDiferenciaDias()"
                  @change="calculaDiasHabiles()"
                  type="date"
                  v-model="form.fecha_desde_rep"
                  label="Fecha inicio"
                  :rules="$validate(['required'])"
                  required
                />
              </v-flex>
              <v-flex md6>
                <v-text-field
                  @input="calculaDiferenciaDias()"
                  @change="calculaDiasHabiles()"
                  type="date"
                  v-model="form.fecha_hasta_rep"
                  label="Fecha fin"
                  :rules="$validate(['required'])"
                  required
                />
              </v-flex>
              <v-flex md4>
                <v-text-field
                  v-if="form.fecha_desde_rep && form.fecha_hasta_rep"
                  v-model="total_dias"
                  label="Días"
                  disabled
                />
              </v-flex>
            </v-layout>
            <!-- <v-layout wrap>
							<v-radio-group
								v-model="form.radio_data"
								row
                required
								:rules="[
                    (v) => {
                      if (v == null) return 'El campo es obligatorio.';
                      return true;
                    },
                  ]"
								>
								<v-flex xs4>
									<v-radio label="Todo el día" :value="0"></v-radio>
								</v-flex>
								<v-flex xs4>
									<v-radio label="Solo mañana" :value="1"></v-radio>
								</v-flex>
								<v-flex xs4>
									<v-radio label="Solo tarde" :value="2"></v-radio>
								</v-flex>
                
								</v-radio-group>
					    </v-layout> -->
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="rgba(14, 187, 178, 0.35)"
            type="submit"
            :loading="loading"
          >
            <v-icon dark>check</v-icon>REPROGRAMAR
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      //url: 'vCronoVacass',
      valid: false,
      fecha_desde: null,
      fecha_hasta: null,
      loading: false,
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      fecha_desde: null,
      fecha_hasta: null,
      persona: null,
      saldo: null,
      periodo: null,
      id: null,
      dias_habiles: 0,
      dias_saldo_repro: 0,
      total_dias: 0,
      motivos_reprogramacion: [
        { id: 1, valor: "Por motivos laborales" },
        { id: 2, valor: "Por motivos personales" },
        { id: 3, valor: "Baja médica" },
        { id: 4, valor: "Otros" },
      ],
    };
  },
  mounted() {
    this.verEstadoVacacion();

    this.$bus.$on("openDialogReprogramarCronograma", async (item) => {
      this.form = item;
      this.dialog = true;
      this.fecha_desde = this.form.fecha_desde.split("/").reverse().join("-");
      this.fecha_hasta = this.form.fecha_hasta.split("/").reverse().join("-");
      await this.calculaDiasHabiles();
      await this.calculoSaldoReprogramar();
    });
  },
  methods: {
    async calculoSaldoReprogramar() {
      // SELECT "vacaciones".fn_saldo_menos_hijos(p_id_vaca_progra integer)
      let dias = 0;
      let respuesta;
      if (this.fecha_desde != null && this.fecha_hasta != null) {
        try {
          respuesta = await this.$service.graphql({
            query: `
                  query{
                    runQuery(consulta:"select vacaciones.fn_saldo_menos_hijos(${parseInt(
                      this.form.id_vacacion_programada
                    )})"){
                      respuesta
                    }
                  }
                `,
          });
          dias = respuesta.runQuery.respuesta[0].fn_saldo_menos_hijos;
        } catch (error) {
          console.log(error);
        }
      }
      this.dias_saldo_repro = dias;
    },
   
    //funcion para obtener dias habiles,se excluyen feriados y fines de semana
    async calculaDiferenciaDias() {
      try {
        let res;
        if (this.form.fecha_desde_rep && this.form.fecha_hasta_rep) {
          res = await this.$service.graphql({
            query: `
							query{
							runQuery(consulta:"select vacaciones.fn_obtiene_dias_habiles_entre_fechas('${this.form.fecha_desde_rep}','${this.form.fecha_hasta_rep}')"){
								respuesta
							}
							}
						`,
          });
          let res2 =
            res.runQuery.respuesta[0].fn_obtiene_dias_habiles_entre_fechas;

          this.total_dias = res2;
          if (
            parseInt(this.form.saldo_a_reprogramar) < parseInt(this.total_dias)
          ) {
            this.$message.info(
              "Se supero el total de dias saldo de su reprogramación"
            );
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async calculaDiasHabiles() {
      // SELECT "control".fn_obtiene_dias_habiles(p_fecha_desde date, p_fecha_hasta date)
      let dias = 0;
      let respuesta;
      if (this.fecha_desde != null && this.fecha_hasta != null) {
        try {
          respuesta = await this.$service.graphql({
            query: `
                  query{
                    runQuery(consulta:"select control.fn_obtiene_dias_habiles('${this.fecha_desde}','${this.fecha_hasta}')"){
                      respuesta
                    }
                  }
                `,
          });
          dias = respuesta.runQuery.respuesta[0].fn_obtiene_dias_habiles;
        } catch (error) {
          console.log(error);
        }
      }
      this.dias_habiles = dias;
    },
    close() {
      (this.form = {}), (this.loading = false);
      this.valid = false;
      this.$bus.$emit("closeDialogReprogramacion");
      this.dialog = false;
    },

    async verEstadoVacacion() {
      let user = this.$storage.get("user");
      let id_funcionario = user.id_funcionario;
      let id_persona = user.id_persona;
      try {
        let res = await this.$service.graphql({
          query: `	
				query{
                  vEstadoVacacions(id_persona: ${id_persona}){
                    rows{
                      nombre
                      dias_saldo
                      dias_asignados
                      dias_utilizados
                      dias_programados
                      dias_cta_vacacion
                      id
                      id_estado
                      id_persona
                      nombre
                      ingreso
                      gestion_desde
                      gestion_hasta
                      cas
                      estado
                      total_dias_saldo
                    }
                  }
                } 
					`,
        });

        this.estado_vacacion = res.vEstadoVacacions.rows;

        this.nombre = this.estado_vacacion[0].nombre;
        this.fecha_ingreso = this.estado_vacacion[0].ingreso;
        this.persona = this.estado_vacacion[0].id_persona;
        this.saldo = this.estado_vacacion[0].dias_saldo;
        // this.periodo = this.estado_vacacion[0].periodo;
        this.id = this.estado_vacacion[0].id;
        //this.sumar_horas_compensa(this.permiso_compensacion);
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      if (this.$refs.form.validate()) {
        // select vacaciones.fn_registra_vacacion_repro(
        //   p_id_reprogramado integer,
        //   p_fecha_desde date,
        //   p_fecha_hasta date,
        //   p_tipo integer,
        //   p_id_funcionario integer)
        if (
          parseInt(this.form.saldo_a_reprogramar) < parseInt(this.total_dias)
        ) {
          this.$confirm(
            "Se supero el total del saldo de días de su reprogramación",
            () => {}
          );
        } else {
          let user = this.$storage.get("user");
          let respuesta;
          try {
            if (this.form.motivo_reprogramacion == "Otros") {
              this.form.motivo_reprogramacion =
                this.form.justificacion_reprogramacion;
            }
            console.log("**", this.form.motivo_reprogramacion);
            console.log(`
              query{
              runQuery(consulta:"select vacaciones.fn_registra_vacacion_reprogramada(${parseInt(
                this.form.id
              )},'${this.form.fecha_desde_rep}','${
              this.form.fecha_hasta_rep
            }',${parseInt(user.id)},'${this.form.motivo_reprogramacion}')"){
                respuesta
              }
            }
            `);
            respuesta = await this.$service.graphql({
              query: `
              query{
              runQuery(consulta:"select vacaciones.fn_registra_vacacion_reprogramada(${parseInt(
                this.form.id
              )},'${this.form.fecha_desde_rep}','${
                this.form.fecha_hasta_rep
              }',${parseInt(user.id)},'${this.form.motivo_reprogramacion}')"){
                respuesta
              }
            }
            `,
            });

            respuesta =
              respuesta.runQuery.respuesta[0].fn_registra_vacacion_reprogramada;
            let resps = respuesta.split("|");
            if (parseInt(resps[0]) == 1) {
              this.$confirm("Reprogramación creada exitosamente", () => {});
              this.loading = false;
              this.close();
            } else {
              if (resps[0] == 0) {
                this.$confirm(resps[1], () => {});
              }
            }
          } catch (error) {
            console.log(error);
          }
        }
      }
    },
  },
};
</script>

<style>
.titulo {
  font-size: 1.07em;
  color: rgb(24, 106, 121);
  font-weight: bold;
}
.texto {
  font-size: 1.07em;
  color: rgb(24, 106, 121);
}
.subtitulo {
  font-size: 1.35em;
  color: rgb(24, 106, 121);
  font-weight: bolder;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
}
.cabecera {
  background-color: rgba(14, 187, 178, 0.35);
  font-size: 1.5em;
  color: rgba(24, 106, 121);
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_reprogramacion/dialogs/ReprogramarCronograma.vue